export default "__VITE_ASSET__hp_49wFv__"